<template>
  <AgentComponent :required-permissions="editPermissions">
    <a
      class="font-bold btn rounded-[1.25rem] btn-light-blue py-0"
      :href="editLink"
      target="_blank"
    >{{ text }}</a>
  </AgentComponent>
</template>

<script>
import agentPermissions from '@layers/web/constants/agent-permissions.js'

const LINK = 'https://i.rolint.se'

export default defineNuxtComponent({
  props: {
    giataId: {
      type: Number,
      default: null,
    },

    tripId: {
      type: Number,
      default: null,
    },

    text: {
      type: String,
      default: 'EDIT',
    },

    edit: {
      type: String,
      default: 'default',
    },
  },

  data () {
    return {
      editPermissions: [agentPermissions.cmsTools],
    }
  },

  computed: {
    editLink () {
      if (this.giataId) {
        switch (this.edit) {
          case 'description':
            return `${LINK}/hotel/descriptionconfig/${this.giataId}`
          default:
            return `${LINK}/hotel/imageconfig/${this.giataId}`
        }
      }

      if (this.tripId) {
        switch (this.edit) {
          default:
            return `${LINK}/pweb/websida-edit/${this.tripId}`
        }
      }

      return LINK
    },
  },
})
</script>
